export default __webpack_public_path__ + "static/media/keto-chocolate-bar@2x.3ad2aec2.png";